<span class="badge"
      *ngIf="valueNumber || showIfZero"
      [class.lg]="size"
      [ngClass]="colorClass" [@enterAnimation]="value">{{value}}</span>
